'use client';

import React, { ReactNode, useState } from 'react';
import styles from './SliderResponsive.module.css';

import { IconChevronLeft, IconChevronRight } from '@/components/icons';
import classNames from 'classnames';

export interface SliderResponsiveProps {
	testId?: string;
	children: ReactNode;
	// Setting an index in case we want to show a specific slide first on mobile
	initialMobileSlideIndex?: number;
}

const SliderResponsive = (props: SliderResponsiveProps) => {
	const {
		testId = 'SliderResponsive',
		children,
		initialMobileSlideIndex = 0,
	} = props;
	const items = React.Children.toArray(children);
	const [currentIndex, setCurrentIndex] = useState(initialMobileSlideIndex);

	const totalItems = items.length;

	const goToPrev = () => {
		setCurrentIndex((prevIndex) =>
			prevIndex === 0 ? totalItems - 1 : prevIndex - 1,
		);
	};

	const goToNext = () => {
		setCurrentIndex((prevIndex) =>
			prevIndex === totalItems - 1 ? 0 : prevIndex + 1,
		);
	};

	return (
		<div className="relative lg:flex lg:items-center">
			<div data-testid={testId} className={'grid lg:mx-25'}>
				{items.map((item, index) => (
					<div
						key={index}
						className={`col-start-1 row-start-1 transition-opacity duration-500 ${
							index === currentIndex ? 'opacity-100' : 'opacity-0 '
						}`}
					>
						{item}
					</div>
				))}
			</div>

			<div className="flex w-full justify-center gap-6 p-4 lg:absolute lg:justify-between">
				<button
					onClick={goToPrev}
					className="group flex h-12 w-12 cursor-pointer items-center justify-center
						rounded-full bg-slate-100 transition-colors duration-200
						hover:bg-sky-600 focus:ring-2 focus-visible:outline-none focus-visible:ring-2"
				>
					<IconChevronLeft
						className={classNames(
							'fill-black hover:fill-white group-hover:fill-white group-active:fill-white',
							styles['button-arrow-icon'],
						)}
					/>
				</button>
				<button
					onClick={goToNext}
					className="group flex h-12 w-12 cursor-pointer items-center justify-center
						rounded-full bg-slate-100 transition-colors duration-200
						hover:bg-sky-600 focus:ring-2 focus-visible:outline-none focus-visible:ring-2"
				>
					<IconChevronRight
						className={classNames(
							'fill-black hover:fill-white group-hover:fill-white group-active:fill-white',
							styles['button-arrow-icon'],
						)}
					/>
				</button>
			</div>
		</div>
	);
};

export default SliderResponsive;
